import { AlpineData } from "@/js/interfaces/Components/alpinejs/Dashboard";
import { createAlpineComponent } from "@nolikein/typed-alpinejs";

/* Generated from the "artisan make:alpine" command */
export default {
    name: 'Dashboard',
    component: (
        // Component parameters...
    ) => createAlpineComponent<AlpineData>({
        // Component properties ...
        expanded: false,
        expandable: true,

        /**
         * Initialize the component
         */
        init() {
            this.$nextTick(() => {
                // Get elemebt with id announce_content
                const announceContent = document.getElementById('announce_content');
                // Throw if element doesnt exists
                if (!announceContent) {
                    throw new Error('Element with id announce_content not found');
                }

                // Check the quantity of lines in the element, then choose if shoudl expand by default (more than 4 lines is expanded by default)
                const lineHeight = parseFloat(getComputedStyle(announceContent).lineHeight || '24');
                const height = announceContent.offsetHeight;
                const lines = height / lineHeight;


                // The limit for our current bloc height is around 3 lines
                if (lines < 3.0) {
                    this.expandable = false;
                }
            });
        },
    }),
};
